"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAbortUserTaskCustomFormMessage = void 0;
const CustomFormMessage_1 = require("./CustomFormMessage");
/**
 * @deprecated This function is deprecated and will be removed in the future. Please use `isTerminateProcessInstanceCustomFormMessage` instead.
 */
function isAbortUserTaskCustomFormMessage(message) {
    return message.type === CustomFormMessage_1.CustomFormMessageType.AbortUserTask;
}
exports.isAbortUserTaskCustomFormMessage = isAbortUserTaskCustomFormMessage;
